import { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Chip } from '@mui/material';
import { fetchWithAuth } from "../utils/fetchWithAuth";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await fetchWithAuth('/users/users', { method: 'GET' }); // adapte le chemin si besoin
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        setUsers([]);
      }
      setLoading(false);
    };
    fetchUsers();
  }, []);

  const handleCopyEmails = () => {
    const emails = users.map(u => u.email).join(", ");
    navigator.clipboard.writeText(emails).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        Utilisateurs
      </Typography>
      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <Chip
          icon={<ContentCopyIcon />}
          label={copied ? "Copié !" : "Copier tous les emails"}
          color={copied ? "success" : "default"}
          onClick={handleCopyEmails}
          sx={{ cursor: "pointer" }}
        />
      </Box>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper} sx={{ marginY: '24px', width: '100%', overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Email</TableCell>
                <TableCell>Rôle</TableCell>
                <TableCell>Plan</TableCell>
                <TableCell>Licences</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date création</TableCell>
                <TableCell>Transcription (min)</TableCell> {/* nouvelle colonne */}
              </TableRow>
            </TableHead>
            <TableBody>
              {users.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                    Aucun utilisateur.
                  </TableCell>
                </TableRow>
              ) : (
                users.map((user) => (
                  <TableRow key={user._id}>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Chip label={user.role} color={user.role === "admin" ? "primary" : "default"} size="small" />
                    </TableCell>
                    <TableCell>
                      <Chip label={user.plan} color={user.plan === "premium" ? "success" : user.plan === "enterprise" ? "warning" : "default"} size="small" />
                    </TableCell>
                    <TableCell>{user.numberOfLicenses || 1}</TableCell>
                    <TableCell>
                      <Chip label={user.status} color={user.status === "active" ? "success" : user.status === "pending" ? "warning" : "default"} size="small" />
                    </TableCell>
                    <TableCell>
                      {user.createdAt ? new Date(user.createdAt).toLocaleDateString("fr-CH") : "-"}
                    </TableCell>
                    <TableCell>
                      {typeof user.transcriptionTime === "number"
                        ? Math.round(user.transcriptionTime / 60)
                        : 0}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default UsersAdmin;